import React from "react";
import TopBar from "../components/common/public/TopBar";
import ReadyToElevate from "../components/common/public/ReadyToElevate";
import PublicFooter from "../components/common/public/Footer";
import useTranslation from "../i18n/useTranslation";

const TermsAndPolicy = () => {
    const { t, getRaw } = useTranslation();

    const renderBullets = (baseKey) => {
        const bullets = getRaw(baseKey, {});

        if (!bullets || typeof bullets !== "object") return null;

        const items = Object.keys(bullets)
            .sort((a, b) => {
                const aNum = parseInt(String(a).replace(/\D/g, ""), 10) || 0;
                const bNum = parseInt(String(b).replace(/\D/g, ""), 10) || 0;
                return aNum - bNum;
            })
            .map((key) => bullets[key])
            .filter(Boolean);

        if (!items.length) return null;

        return (
            <ul
                className="mt-2 text-justify"
                style={{ color: "#ffffff", textAlign: "left" }}
            >
                {items.map((item, index) => (
                    <li key={`${baseKey}-${index}`}>{item}</li>
                ))}
            </ul>
        );
    };

    return (
        <div
            style={{
                backgroundColor: "#14151a",
                color: "#ffffff",
                fontFamily: "'Poppins', sans-serif",
                overflowX: "hidden",
            }}
        >
            <TopBar imgPath={"/dist/img/angeonx-sports.png"} />

            <div
                className="container"
                style={{ margin: "0 auto", maxWidth: "1200px", padding: "0 20px" }}
            >
                <div
                    className="jumbotron text-center p-5 rounded"
                    style={{ backgroundColor: "#1f1f2e", color: "var(--kbs-primary, #00adff)" }}
                >
                    <h1>{t("termsPolicy.heroTitle")}</h1>

                    <div className="card-body text-center">
                        <p style={{ color: "#ffffff", marginTop: "1rem" }}>
                            <b>{t("termsPolicy.effectiveDateLabel")}:</b>{" "}
                            {t("termsPolicy.effectiveDate")}
                        </p>

                        <p style={{ color: "#ffffff" }}>
                            <b>{t("termsPolicy.lastUpdatedLabel")}:</b>{" "}
                            {t("termsPolicy.lastUpdated")}
                        </p>

                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.intro.p1")}
                        </p>

                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.intro.p2")}
                        </p>

                        <div
                            className="mt-4 p-3 rounded text-left"
                            style={{
                                border: "1px solid rgba(var(--kbs-primary-rgb, 0,173,255), 0.35)",
                                backgroundColor: "rgba(var(--kbs-primary-rgb, 0,173,255), 0.08)",
                                color: "#ffffff",
                            }}
                        >
                            <p className="mb-2 text-bold" style={{ color: "var(--kbs-primary, #00adff)" }}>
                                {t("termsPolicy.summary.title")}
                            </p>
                            <p className="mb-2 text-justify" style={{ color: "#ffffff" }}>
                                {t("termsPolicy.summary.p1")}
                            </p>
                            {renderBullets("termsPolicy.summary.bullets")}
                        </div>

                        <p className="h4 mt-4 text-justify text-bold">
                            {t("termsPolicy.termsOfService.title")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.eligibility.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.eligibility.p1")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.userAccounts.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.userAccounts.p1")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.userAccounts.bullets")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.userAccounts.p2")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.platformPurpose.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.platformPurpose.p1")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.platformPurpose.bullets")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.platformPurpose.p2")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.userConduct.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.userConduct.p1")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.userConduct.bullets")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.userConduct.p2")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.userGeneratedContent.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.userGeneratedContent.p1")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.userGeneratedContent.p2")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.userGeneratedContent.p3")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.refereeRatings.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.refereeRatings.p1")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.refereeRatings.bullets")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.refereeRatings.p2")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.subscriptions.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.subscriptions.p1")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.subscriptions.bullets1")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.subscriptions.p2")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.subscriptions.p3")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.subscriptions.p4")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.subscriptions.bullets2")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.subscriptions.p5")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.stripe.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.stripe.p1")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.stripe.p2")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.stripe.bullets")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.stripe.p3")}{" "}
                            <a
                                href="https://stripe.com/legal"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "var(--kbs-primary, #00adff)" }}
                            >
                                https://stripe.com/legal
                            </a>{" "}
                            {t("common.and", {}, "and")}{" "}
                            <a
                                href="https://stripe.com/privacy"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "var(--kbs-primary, #00adff)" }}
                            >
                                https://stripe.com/privacy
                            </a>
                            .
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.stripe.p4")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.stripe.bullets2")}

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.thirdParty.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.thirdParty.p1")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.thirdParty.bullets")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.thirdParty.p2")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.intellectualProperty.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.intellectualProperty.p1")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.intellectualProperty.p2")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.intellectualProperty.p3")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.marketingRights.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.marketingRights.p1")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.marketingRights.bullets1")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.marketingRights.p2")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.marketingRights.bullets2")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.marketingRights.p3")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.marketingRights.bullets3")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.marketingRights.p4")}{" "}
                            <a href="mailto:kbolasports@angeonx.com" style={{ color: "var(--kbs-primary, #00adff)" }}>
                                {t("termsPolicy.termsOfService.marketingRights.email")}
                            </a>
                            .
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.advertising.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.advertising.p1")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.advertising.p2")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.serviceAvailability.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.serviceAvailability.p1")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.serviceAvailability.p2")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.serviceAvailability.bullets")}

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.limitation.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.limitation.p1")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.limitation.bullets")}

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.indemnification.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.indemnification.p1")}
                        </p>
                        {renderBullets("termsPolicy.termsOfService.indemnification.bullets")}

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.governingLaw.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.termsOfService.governingLaw.p1")}
                        </p>

                        <p className="h4 mt-4 text-justify text-bold">
                            {t("termsPolicy.privacyPolicy.title")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.collect.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.collect.p1")}
                        </p>
                        {renderBullets("termsPolicy.privacyPolicy.collect.bullets")}

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.payments.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.payments.p1")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.useData.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.useData.p1")}
                        </p>
                        {renderBullets("termsPolicy.privacyPolicy.useData.bullets")}

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.contactSharing.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.contactSharing.p1")}
                        </p>
                        {renderBullets("termsPolicy.privacyPolicy.contactSharing.bullets")}

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.dataSharing.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.dataSharing.p1")}
                        </p>
                        {renderBullets("termsPolicy.privacyPolicy.dataSharing.bullets")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.dataSharing.p2")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.retention.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.retention.p1")}
                        </p>
                        {renderBullets("termsPolicy.privacyPolicy.retention.bullets")}

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.security.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.security.p1")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.children.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.children.p1")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.children.p2")}{" "}
                            <a href="mailto:kbolasports@angeonx.com" style={{ color: "var(--kbs-primary, #00adff)" }}>
                                {t("termsPolicy.privacyPolicy.children.email")}
                            </a>{" "}
                            {t("termsPolicy.privacyPolicy.children.p3")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.international.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.international.p1")}
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.rights.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.rights.p1")}
                        </p>
                        {renderBullets("termsPolicy.privacyPolicy.rights.bullets")}
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.rights.p2")}{" "}
                            <a href="mailto:kbolasports@angeonx.com" style={{ color: "var(--kbs-primary, #00adff)" }}>
                                {t("termsPolicy.privacyPolicy.rights.email")}
                            </a>
                            .
                        </p>

                        <p className="mt-3 text-justify text-bold" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.updates.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.privacyPolicy.updates.p1")}
                        </p>

                        <p className="h4 mt-4 text-justify text-bold">
                            {t("termsPolicy.contact.title")}
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.contact.p1")}
                        </p>
                        <p className="mt-2 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.contact.company")} <br />
                            {t("termsPolicy.contact.city")} <br />
                            📩 {t("termsPolicy.contact.emailLabel")}:{" "}
                            <a href="mailto:kbolasports@angeonx.com" style={{ color: "var(--kbs-primary, #00adff)" }}>
                                {t("termsPolicy.contact.email")}
                            </a>
                        </p>
                        <p className="mt-3 text-justify" style={{ color: "#ffffff" }}>
                            {t("termsPolicy.contact.p2")}
                        </p>
                    </div>
                </div>

                <ReadyToElevate />
            </div>

            <PublicFooter imgPath={"/dist/img/"} />
        </div>
    );
};

export default TermsAndPolicy;
